export const TraditionalBetTypes: Array<number> = [
    144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 0, 1, 2, 3, 4,
    5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24,
    25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43,
    44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62,
    63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81,
    82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100,
    101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115,
    116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 130,
    131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 156,
];

export const RacetrackBetTypes: Array<number> = [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
    21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39,
    40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58,
    59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77,
    78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96,
    97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112,
    113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127,
    128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142,
    143, 156,
];

export const TraditionalPortraitCheckOpacityTapAreas = [
    'tp_0_0',
    'tp_1_1',
    'tp_4_4',
    'tp_7_7',
    'tp_10_10',
    'tp_13_13',
    'tp_16_16',
    'tp_19_19',
    'tp_22_22',
    'tp_25_25',
    'tp_28_28',
    'tp_31_31',
    'tp_34_34',
    'tp_147_147',
    'tp_2_2',
    'tp_5_5',
    'tp_8_8',
    'tp_11_11',
    'tp_14_14',
    'tp_17_17',
    'tp_20_20',
    'tp_23_23',
    'tp_26_26',
    'tp_29_29',
    'tp_32_32',
    'tp_35_35',
    'tp_148_148',
    'tp_3_3',
    'tp_6_6',
    'tp_9_9',
    'tp_12_12',
    'tp_15_15',
    'tp_18_18',
    'tp_21_21',
    'tp_24_24',
    'tp_27_27',
    'tp_30_30',
    'tp_33_33',
    'tp_36_36',
    'tp_149_149',
    'tp_144_144',
    'tp_145_145',
    'tp_146_146',
    'tp_150_150',
    'tp_153_153',
    'tp_154_154',
    'tp_155_155',
    'tp_152_152',
    'tp_151_151',
];

export const TraditionalPortraitBetTypeFlashAreas = [
    'tpf_0_0',
    'tpf_1_1',
    'tpf_4_4',
    'tpf_7_7',
    'tpf_10_10',
    'tpf_13_13',
    'tpf_16_16',
    'tpf_19_19',
    'tpf_22_22',
    'tpf_25_25',
    'tpf_28_28',
    'tpf_31_31',
    'tpf_34_34',
    'tpf_147_147',
    'tpf_2_2',
    'tpf_5_5',
    'tpf_8_8',
    'tpf_11_11',
    'tpf_14_14',
    'tpf_17_17',
    'tpf_20_20',
    'tpf_23_23',
    'tpf_26_26',
    'tpf_29_29',
    'tpf_32_32',
    'tpf_35_35',
    'tpf_148_148',
    'tpf_3_3',
    'tpf_6_6',
    'tpf_9_9',
    'tpf_12_12',
    'tpf_15_15',
    'tpf_18_18',
    'tpf_21_21',
    'tpf_24_24',
    'tpf_27_27',
    'tpf_30_30',
    'tpf_33_33',
    'tpf_36_36',
    'tpf_149_149',
    'tpf_144_144',
    'tpf_145_145',
    'tpf_146_146',
    'tpf_150_150',
    'tpf_153_153',
    'tpf_154_154',
    'tpf_155_155',
    'tpf_152_152',
    'tpf_151_151',
];

export const TraditionalLandscapeCheckOpacityTapAreas = [
    'tl_0_0',
    'tl_3_3',
    'tl_6_6',
    'tl_9_9',
    'tl_12_12',
    'tl_15_15',
    'tl_18_18',
    'tl_21_21',
    'tl_24_24',
    'tl_27_27',
    'tl_30_30',
    'tl_33_33',
    'tl_36_36',
    'tl_149_149',
    'tl_2_2',
    'tl_5_5',
    'tl_8_8',
    'tl_11_11',
    'tl_14_14',
    'tl_17_17',
    'tl_20_20',
    'tl_23_23',
    'tl_26_26',
    'tl_29_29',
    'tl_32_32',
    'tl_35_35',
    'tl_148_148',
    'tl_1_1',
    'tl_4_4',
    'tl_7_7',
    'tl_10_10',
    'tl_13_13',
    'tl_16_16',
    'tl_19_19',
    'tl_22_22',
    'tl_25_25',
    'tl_28_28',
    'tl_31_31',
    'tl_34_34',
    'tl_147_147',
    'tl_144_144',
    'tl_145_145',
    'tl_146_146',
    'tl_150_150',
    'tl_153_153',
    'tl_154_154',
    'tl_155_155',
    'tl_152_152',
    'tl_151_151',
];

export const TraditionalLandscapeBetTypeFlashAreas = [
    'tlf_0_0',
    'tlf_3_3',
    'tlf_6_6',
    'tlf_9_9',
    'tlf_12_12',
    'tlf_15_15',
    'tlf_18_18',
    'tlf_21_21',
    'tlf_24_24',
    'tlf_27_27',
    'tlf_30_30',
    'tlf_33_33',
    'tlf_36_36',
    'tlf_149_149',
    'tlf_2_2',
    'tlf_5_5',
    'tlf_8_8',
    'tlf_11_11',
    'tlf_14_14',
    'tlf_17_17',
    'tlf_20_20',
    'tlf_23_23',
    'tlf_26_26',
    'tlf_29_29',
    'tlf_32_32',
    'tlf_35_35',
    'tlf_148_148',
    'tlf_1_1',
    'tlf_4_4',
    'tlf_7_7',
    'tlf_10_10',
    'tlf_13_13',
    'tlf_16_16',
    'tlf_19_19',
    'tlf_22_22',
    'tlf_25_25',
    'tlf_28_28',
    'tlf_31_31',
    'tlf_34_34',
    'tlf_147_147',
    'tlf_144_144',
    'tlf_145_145',
    'tlf_146_146',
    'tlf_150_150',
    'tlf_153_153',
    'tlf_154_154',
    'tlf_155_155',
    'tlf_152_152',
    'tlf_151_151',
];

export const RacetrackPortraitCheckOpacityTapAreas = [
    'rp_0_0',
    'rp_1_1',
    'rp_2_2',
    'rp_3_3',
    'rp_4_4',
    'rp_5_5',
    'rp_6_6',
    'rp_7_7',
    'rp_8_8',
    'rp_9_9',
    'rp_10_10',
    'rp_11_11',
    'rp_12_12',
    'rp_13_13',
    'rp_14_14',
    'rp_15_15',
    'rp_16_16',
    'rp_17_17',
    'rp_18_18',
    'rp_19_19',
    'rp_20_20',
    'rp_21_21',
    'rp_22_22',
    'rp_23_23',
    'rp_24_24',
    'rp_25_25',
    'rp_26_26',
    'rp_27_27',
    'rp_28_28',
    'rp_29_29',
    'rp_30_30',
    'rp_31_31',
    'rp_32_32',
    'rp_33_33',
    'rp_34_34',
    'rp_35_35',
    'rp_36_36',
    'rp_1503_1503',
    'rp_1501_1501',
    'rp_1500_1500',
    'rp_1502_1502',
    'rp_1005_1005',
    'rp_1016_1016',
    'rp_1024_1024',
    'rp_1010_1010',
    'rp_1023_1023',
    'rp_1008_1008',
    'rp_1011_1011',
    'rp_1030_1030',
    'rp_1033_1033',
    'rp_1001_1001',
    'rp_1020_1020',
    'rp_1014_1014',
    'rp_1031_1031',
    'rp_1009_1009',
    'rp_1022_1022',
    'rp_1018_1018',
    'rp_1029_1029',
    'rp_1007_1007',
    'rp_1036_1036',
    'rp_1013_1013',
    'rp_1027_1027',
    'rp_1006_1006',
    'rp_1034_1034',
    'rp_1017_1017',
    'rp_1025_1025',
    'rp_1002_1002',
    'rp_1021_1021',
    'rp_1004_1004',
    'rp_1028_1028',
    'rp_1035_1035',
    'rp_1019_1019',
    'rp_1012_1012',
    'rp_1003_1003',
    'rp_1032_1032',
    'rp_1000_1000',
    'rp_1026_1026',
    'rp_1015_1015',
];

export const RacetrackPortraitBetTypeFlashAreas = [
    'rpf_0_0',
    'rpf_1_1',
    'rpf_2_2',
    'rpf_3_3',
    'rpf_4_4',
    'rpf_5_5',
    'rpf_6_6',
    'rpf_7_7',
    'rpf_8_8',
    'rpf_9_9',
    'rpf_10_10',
    'rpf_11_11',
    'rpf_12_12',
    'rpf_13_13',
    'rpf_14_14',
    'rpf_15_15',
    'rpf_16_16',
    'rpf_17_17',
    'rpf_18_18',
    'rpf_19_19',
    'rpf_20_20',
    'rpf_21_21',
    'rpf_22_22',
    'rpf_23_23',
    'rpf_24_24',
    'rpf_25_25',
    'rpf_26_26',
    'rpf_27_27',
    'rpf_28_28',
    'rpf_29_29',
    'rpf_30_30',
    'rpf_31_31',
    'rpf_32_32',
    'rpf_33_33',
    'rpf_34_34',
    'rpf_35_35',
    'rpf_36_36',
];

export const RacetrackLandscapeCheckOpacityTapAreas = [
    'rl_1005_1005',
    'rl_1008_1008',
    'rl_1010_1010',
    'rl_1023_1023',
    'rl_1024_1024',
    'rl_1016_1016',
    'rl_1033_1033',
    'rl_1001_1001',
    'rl_1020_1020',
    'rl_1014_1014',
    'rl_1031_1031',
    'rl_1009_1009',
    'rl_1022_1022',
    'rl_1018_1018',
    'rl_1029_1029',
    'rl_1007_1007',
    'rl_1028_1028',
    'rl_1012_1012',
    'rl_1030_1030',
    'rl_1011_1011',
    'rl_1036_1036',
    'rl_1013_1013',
    'rl_1027_1027',
    'rl_1006_1006',
    'rl_1034_1034',
    'rl_1017_1017',
    'rl_1025_1025',
    'rl_1002_1002',
    'rl_1021_1021',
    'rl_1004_1004',
    'rl_1019_1019',
    'rl_1015_1015',
    'rl_1000_1000',
    'rl_1032_1032',
    'rl_1026_1026',
    'rl_1035_1035',
    'rl_1003_1003',
    'rl_1503_1503',
    'rl_1502_1502',
    'rl_1501_1501',
    'rl_1500_1500',
];

export const RacetrackNumbers = [
    10, 23, 8, 30, 11, 36, 13, 27, 6, 34, 17, 25, 2, 21, 4, 19, 15, 32, 0, 26,
    3, 35, 12, 28, 7, 29, 18, 22, 9, 31, 14, 20, 1, 33, 16, 24, 5,
];

export const RacetrackLabels = [
    1000, 1001, 1002, 1003, 1004, 1005, 1006, 1007, 1008, 1009, 1010, 1011,
    1012, 1013, 1014, 1015, 1016, 1017, 1018, 1019, 1020, 1021, 1022, 1023,
    1024, 1025, 1026, 1027, 1028, 1029, 1030, 1031, 1032, 1033, 1034, 1035,
    1036, 1500, 1501, 1502, 1503,
];

export const MultipierResultDelay = [
    0.09, 0.11, 0.1, 0.08, 0.12, 0.09, 0.1, 0.11, 0.08, 0.12, 0.09, 0.1, 0.11,
    0.08, 0.12, 0.09, 0.1, 0.11, 0.08, 0.12, 0.09, 0.1, 0.11, 0.08, 0.12, 0.09,
    0.1, 0.11, 0.08, 0.12, 0.09, 0.1, 0.11, 0.08, 0.12, 0.09, 0.1,
];

export const NonSpineMultipierTPIds = [
    'urmtp_0',
    'urmtp_1',
    'urmtp_2',
    'urmtp_3',
    'urmtp_4',
    'urmtp_5',
    'urmtp_6',
    'urmtp_7',
    'urmtp_8',
    'urmtp_9',
    'urmtp_10',
    'urmtp_11',
    'urmtp_12',
    'urmtp_13',
    'urmtp_14',
    'urmtp_15',
    'urmtp_16',
    'urmtp_17',
    'urmtp_18',
    'urmtp_19',
    'urmtp_20',
    'urmtp_21',
    'urmtp_22',
    'urmtp_23',
    'urmtp_24',
    'urmtp_25',
    'urmtp_26',
    'urmtp_27',
    'urmtp_28',
    'urmtp_29',
    'urmtp_30',
    'urmtp_31',
    'urmtp_32',
    'urmtp_33',
    'urmtp_34',
    'urmtp_35',
    'urmtp_36',
];

export const NonSpineMultipierTLIds = [
    'urmtl_0',
    'urmtl_1',
    'urmtl_2',
    'urmtl_3',
    'urmtl_4',
    'urmtl_5',
    'urmtl_6',
    'urmtl_7',
    'urmtl_8',
    'urmtl_9',
    'urmtl_10',
    'urmtl_11',
    'urmtl_12',
    'urmtl_13',
    'urmtl_14',
    'urmtl_15',
    'urmtl_16',
    'urmtl_17',
    'urmtl_18',
    'urmtl_19',
    'urmtl_20',
    'urmtl_21',
    'urmtl_22',
    'urmtl_23',
    'urmtl_24',
    'urmtl_25',
    'urmtl_26',
    'urmtl_27',
    'urmtl_28',
    'urmtl_29',
    'urmtl_30',
    'urmtl_31',
    'urmtl_32',
    'urmtl_33',
    'urmtl_34',
    'urmtl_35',
    'urmtl_36',
];

export const NonSpineMultipierRPIds = [
    'urmrp_0',
    'urmrp_1',
    'urmrp_2',
    'urmrp_3',
    'urmrp_4',
    'urmrp_5',
    'urmrp_6',
    'urmrp_7',
    'urmrp_8',
    'urmrp_9',
    'urmrp_10',
    'urmrp_11',
    'urmrp_12',
    'urmrp_13',
    'urmrp_14',
    'urmrp_15',
    'urmrp_16',
    'urmrp_17',
    'urmrp_18',
    'urmrp_19',
    'urmrp_20',
    'urmrp_21',
    'urmrp_22',
    'urmrp_23',
    'urmrp_24',
    'urmrp_25',
    'urmrp_26',
    'urmrp_27',
    'urmrp_28',
    'urmrp_29',
    'urmrp_30',
    'urmrp_31',
    'urmrp_32',
    'urmrp_33',
    'urmrp_34',
    'urmrp_35',
    'urmrp_36',
];

export const NonSpineMultipierRLIds = [
    'urmrl_0',
    'urmrl_1',
    'urmrl_2',
    'urmrl_3',
    'urmrl_4',
    'urmrl_5',
    'urmrl_6',
    'urmrl_7',
    'urmrl_8',
    'urmrl_9',
    'urmrl_10',
    'urmrl_11',
    'urmrl_12',
    'urmrl_13',
    'urmrl_14',
    'urmrl_15',
    'urmrl_16',
    'urmrl_17',
    'urmrl_18',
    'urmrl_19',
    'urmrl_20',
    'urmrl_21',
    'urmrl_22',
    'urmrl_23',
    'urmrl_24',
    'urmrl_25',
    'urmrl_26',
    'urmrl_27',
    'urmrl_28',
    'urmrl_29',
    'urmrl_30',
    'urmrl_31',
    'urmrl_32',
    'urmrl_33',
    'urmrl_34',
    'urmrl_35',
    'urmrl_36',
];
